import React from 'react';
import { US_REGION } from '../../app-legal-regions';
import styles from './PauseSlideContentV14.css';

function PauseSlideContentV14({
    heading = 'It isn’t your memory failing. It’s how memory works.',
    description = 'Memory keeps the shape of things and lets the details go — the name of the street, the year, what he actually said. Everyone’s does. The details stay only ',
    emphasis = 'where someone wrote them down.',
    statValue = '1 in 7',
    statText = 'adults aged 75+ said confusion or memory loss had become more frequent or worse during the previous year',
    statTextUs = 'Americans aged 75+ said confusion or memory loss had become more frequent or worse during the previous year',
    statSource = '*CDC, BRFSS 2015–2016 (14.3%)',
    withSeparateEmphasis = false,
    legalRegion
}) {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>{heading}</h2>
                {withSeparateEmphasis
                    ? (
                        <div className={styles.descriptionGroup}>
                            <p className={styles.description}>{description}</p>
                            <p className={styles.emphasis}>{emphasis}</p>
                        </div>
                    )
                    : (
                        <p className={styles.description}>
                            {description}<strong>{emphasis}</strong>
                        </p>
                    )
                }
            </div>
            <figure className={styles.statCard}>
                <div className={styles.stat}>
                    <p className={styles.statValue}>{statValue}</p>
                    <p className={styles.statText}>{legalRegion === US_REGION ? statTextUs : statText}</p>
                </div>
                <figcaption className={styles.statSource}>{statSource}</figcaption>
            </figure>
        </div>
    );
}

export {
    PauseSlideContentV14
};
